export default __webpack_public_path__ + "static/media/banner.b9a6eafc.jpg";